module.exports = __webpack_public_path__ + "img/MenuButton_CK.6a73ea57.png";